import { STATUS_VALUES } from '@esentai/core/features/kkms/consts/keys';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import BackButton from '@/components/BackButton';
import Breadcrumbs, { Breadcrumb } from '@/components/Breadcrumbs';
import Page from '@/components/Page';
import PageContent from '@/components/PageContent';
import PageHeader from '@/components/PageHeader';
import PageTitle from '@/components/PageTitle';
import PaperSheet from '@/components/PaperSheet';
import KkmNameLazy from '@/containers/KkmNameLazy';
import StoreNameLazy from '@/containers/StoreNameLazy';
import UserNameLazy from '@/containers/UserNameLazy';
import { ROUTE_PATH as KKMS_PATH } from '@/features/kkmsPage/consts';
import { dateTimeFormat } from '@/utils/format';

import { HistoryPage } from '../../HistoryPage/HistoryPage';
import Actions from './Actions';
import Description from './Description';

const historyHeaders = [
  'ID',
  'Магазин',
  'Статус',
  'Пользователь',
  'Дата изменения',
  'Комментарий',
];

class Kkm extends Component {
  static propTypes = {
    isLoaded: PropTypes.bool.isRequired,
    itemId: PropTypes.string.isRequired,
  };

  render() {
    const { isLoaded, itemId } = this.props;

    if (!isLoaded) {
      return null;
    }

    return (
      <>
        <Page>
          <PageHeader gutterBottom={false}>
            <Breadcrumbs>
              <Breadcrumb to={KKMS_PATH}>Справочник ККМ</Breadcrumb>
            </Breadcrumbs>
            <BackButton />
            <PageTitle>
              <KkmNameLazy kkmId={itemId} />
            </PageTitle>
          </PageHeader>
          <PageContent>
            <PaperSheet>
              <Description kkmId={itemId} />
              <Actions />
            </PaperSheet>
          </PageContent>
        </Page>
        <HistoryPage
          model="cash_machine"
          objectId={itemId}
          headers={historyHeaders}
        >
          {rows =>
            rows.map(row => (
              <TableRow key={row.id}>
                <TableCell>{row.data.fns_id}</TableCell>
                <TableCell>
                  <StoreNameLazy storeId={row.data.store_id} />
                </TableCell>
                <TableCell>{STATUS_VALUES[row.data.status]}</TableCell>
                <TableCell>
                  <UserNameLazy userId={row.user_id} />
                </TableCell>
                <TableCell>{dateTimeFormat(row.record_created)}</TableCell>
                <TableCell>{row.comment}</TableCell>
              </TableRow>
            ))
          }
        </HistoryPage>
      </>
    );
  }
}

export default Kkm;
